import { ActionButton, AddressBookService, DeliveryParameters, TicketActionType, TicketService } from '@fgb/core';
import { iif, of, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TicketTransferConfirmModalComponent } from '@fgb/portal-component-library/src/lib/ticket-transfer';
import { RecipientFormActionPayload } from './recipient-form-payload.model';


export interface TicketTransferActionPayload extends RecipientFormActionPayload {
}

/**
 * This action class is reusable and can be used to transfer tickets. 
 */
export class TicketTransferAction extends ActionButton {

    invoke(payload: TicketTransferActionPayload): void {
        const addressService = inject(AddressBookService);
        const ticketService = inject(TicketService);
        const translateService = inject(TranslateService);
        const modalService = inject(NgbModal);
        const router = inject(Router);
        let deliveryParameters = new DeliveryParameters();
        deliveryParameters.EmailAddress = payload.EmailAddress;
        deliveryParameters.TicketAction = TicketActionType.TransferToEmail;
        deliveryParameters.FirstName = payload.FullName;

        const modalRef = modalService.open(TicketTransferConfirmModalComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'ticket-transfer-confirm-modal', centered: true });
        modalRef.componentInstance.emailAddress = payload.EmailAddress;
        modalRef.result.then((result) => {
            
            if( result ){
                this.loading = true;
                // If saveRecipient is true, add the recipient to the address book otherwise just transfer the ticket
                const request$ = iif(() => payload.saveRecipient, addressService.add(payload.FullName, payload.EmailAddress), of(payload));

                // @TODO: clean up
                request$.pipe(
                    switchMap(() => ticketService.transferTicket(deliveryParameters))
                ).subscribe({
                    next: (result) => {
                        if (result && result.length > 0) {
                            if (result[0].Result.ErrorNumber === 0) {
                                // @TODO:
                                //   let selectedTickets = this.ticketQuery.getAll({ filterBy: (ticket) => ticket.selected });
                                //   selectedTickets.map((ticket) => this.ticketService.setTransferredTicket(ticket.Id, deliveryParameters.EmailAddress));
                                router.navigate(['ticketTransfer/success']);
                            }else {
                                this.errorMessage = translateService.instant('fgbcl.ticket.transfer.action.error.' + result[0].Result.ErrorNumber);
                            }
                        }else{
                            this.errorMessage = translateService.instant('fgbcl.ticket.api.transfer.action.error');
                        } 
                    },
                    error: (error) => {
                        this.loading = false;
                        if( error instanceof Error ){
                            this.errorMessage = translateService.instant('fgbcl.ticket.transfer.action.error');
                        }else{
                            this.errorMessage = translateService.instant('fgbcl.ticket.api.transfer.action.error.');
                        }
                    },
                    complete: () => {
                        this.loading = false;
                    }
                });
            }
        })
       
            
    }
}